import _, { isEmpty, isArray } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';

export const extractUGC = ({
    general,
    overview,
    description,
    workflow,
    workProcess,
    sellerCard,
    faq,
    packages = {},
    studio = {}
}) => {
    const { gig } = overview;
    const { title } = gig;
    const { isStudio } = general;

    return {
        gigTitle: getTitle({ isStudio, title }),
        description: _.pick(description, 'content'),
        workflow: extractWorkflowContent(workflow),
        workProcess: extractWorkProcessContent(workProcess),
        sellerCard: _.pick(sellerCard, ['description', 'oneLiner']),
        studio: extractStudioContent(studio),
        faq,
        listings: {},
        galleryReviews: {},
        personalization: {},
        packages: extractPackagesContent(packages)
    };
};

/**
 * Get the title of the gig as entered by the seller (UGC) together with the correct
 * Prefix of "I will" for regular seller or "Our studio will" for studios.
 * For example: If the gig title is "design a logo for you"
 * Output when isStudio is false should be: "I will design a logo for you"
 * @param {Boolean} isStudio - Either the gig seller is a studio or not
 * @param {String} title - The gig title the seller entered (UGC)
 * @returns {String} Translation of the gig title prefix with the UGC as parameter
 */
export const getTitle = ({ isStudio, title }) => {
    const { locale } = getContext();
    const key = isStudio ? 'our_studio_will' : 'i_will';

    return i18n.t(`gig_page_perseus.general.${key}`, { $scope: locale, title });
};

const extractPackagesContent = ({ packageList = [] }) => {
    const packages = {};

    packageList.forEach(({ title, description, customExtras = [], id }) => {
        packages[id] = {
            title,
            description,
            customExtras: customExtras.map(({ label, buyerTooltip }) => ({ label, buyerTooltip }))
        };
    });

    return packages;
};

const extractStudioContent = ({ info }) => _.pick(info, ['tagline']);

/**
 * Extract workflow content for machine translations.
 * @param {Object} workflow
 * @returns Workflow texts content
 */
export const extractWorkflowContent = (workflow) => {
    if (_.isEmpty(workflow)) {
        return {};
    }

    return {
        steps: workflow.steps.map((step) => _.pick(step, ['title', 'description']))
    };
};

/**
 * Extract workProcess content for machine translations.
 * @param {Object} workProcess
 * @returns {Object} workProcess texts content
 */
export const extractWorkProcessContent = (workProcess) => {
    if (isEmpty(workProcess) || !isArray(workProcess.milestones)) {
        return {};
    }

    return {
        milestones: workProcess.milestones.map(({ title, description, steps }) => ({
            title,
            description,
            steps: isArray(steps) ? steps.map(({ title, description }) => ({ title, description })) : []
        }))
    };
};
